import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
import { RedirectComponent } from './redirect/redirect.component';

const routes: Routes = [
  { 
    path: '', 
    redirectTo: 'ng', 
    pathMatch: 'full' 
  },
  {
    path: ':country',
    children: [
      { 
        path: '', 
        redirectTo: 'app', 
        pathMatch: 'full' 
      },
      {
        path: '',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'app',
        loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule)
      },
      {
        path: 'travel-essentials',
        loadChildren: () => import('./travel-protocols/travel-protocols.module').then(m => m.TravelProtocolsModule)
      },
      {
        path: 'events-management',
        loadChildren: () => import('./events-management/events-management.module').then(m => m.EventsManagementModule)
      },
    ]
  }  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',  // always scroll to top on navigation
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
